export default __webpack_public_path__ + "static/media/consent_signup.7d3cff96.pdf";